// extracted by mini-css-extract-plugin
module.exports = {"tabs":"tablist_tabs__nzoLq","tabList":"tablist_tabList__JnuuN","botons":"tablist_botons__7ekpb"};